import { useState } from 'react'
import { Building2 } from 'lucide-react'

interface CompanyLogoProps {
  domain: string | null
  name: string
}

export function CompanyLogo({ domain, name }: CompanyLogoProps) {
  const [logoSource, setLogoSource] = useState<'clearbit' | 'google' | 'fallback'>('clearbit')

  // No domain - show fallback immediately
  if (!domain) {
    return (
      <div className="w-9 h-9 rounded-lg bg-[var(--bg-tertiary)] flex items-center justify-center flex-shrink-0">
        <Building2 size={18} className="text-[var(--text-muted)]" />
      </div>
    )
  }

  // Show fallback icon
  if (logoSource === 'fallback') {
    return (
      <div className="w-9 h-9 rounded-lg bg-[var(--bg-tertiary)] flex items-center justify-center flex-shrink-0">
        <Building2 size={18} className="text-[var(--text-muted)]" />
      </div>
    )
  }

  // Try Clearbit first, then Google favicon, then fallback
  const logoUrl = logoSource === 'clearbit'
    ? `https://logo.clearbit.com/${domain}`
    : `https://www.google.com/s2/favicons?domain=${domain}&sz=64`

  return (
    <img
      src={logoUrl}
      alt={name}
      className="w-9 h-9 rounded-lg object-contain bg-[var(--bg-tertiary)] flex-shrink-0"
      onError={() => {
        if (logoSource === 'clearbit') {
          setLogoSource('google')
        } else {
          setLogoSource('fallback')
        }
      }}
    />
  )
}
